// The list signals' and saved views' own words (lane B10, slice S19): the sentence Search Readiness carries beside a
// requisition whose Compensation review is still open, the saved view's name field, its archive verb and the notice
// for a filter a saved view held that no longer applies for this reader. Every entry quotes his glossary or the
// vendored design-system excerpts; the D0 label suites discover this module (a lane folder of src/views) and hold it to
// the same rules as src/mc. Words the design system already defines (Req health, Search Readiness, Missing
// prerequisites, Saved views, Save view, Save, Cancel, the band words and the role words) are imported from it, never
// redefined here.

import { defineLabels } from "@/mc/labels";

const SEARCH_READINESS =
  "\"Search Readiness percent with missing prerequisites; posting is not blocked by pending Compensation.\"";
const SAVED_VIEW = "| Saved view | \"SavedView\"; filters \"saved views, grouping, sorting\".";
const ARCHIVE = "| Archived / Archive | \"Filled/Cancelled archive immediately and remain searchable/reportable/auditable/reopenable.\"";
const MASKED = "a security-trimmed row: `--text-3` on `--t-neutral`, no title, no link, the words *subject to permission*";

/** S19's words: posting apart from readiness (DC-50), the saved view's name and archive, a dropped filter. */
export const LIST_LABELS = /* @__PURE__ */ defineLabels({
  postingNotBlocked: { text: "Posting is not blocked by pending Compensation." },
  savedView: { text: "Saved view" },
  archive: { text: "Archive" },
  subjectToPermission: { text: "Subject to permission" },
});
